import once from '../../../src/js/utils/once.js';

/* global requestAnimationFrame Drupal */

/**
 * Adds an attribute to each field of the form if it was focused and then blured again.
 * This is to avoid that a field is marked as invalid by the browser
 * before the user had a chance to fill in something (i.e. before the input was focused).
 *
 * For further enhancement see https://developer.mozilla.org/en-US/docs/Learn/Forms/Form_validation#the_constraint_validation_api
 *
 * @param formSelector The selector to obtain the form element(s).
 * @param focusedAttributeName The attribute name which should be added to the input element
 *                             once it was focused and blured again.
 */
export default function initFormElementFocusedState({
    formSelector = '.js-form',
    focusedAttributeName = 'data-has-been-focused',
} = {}) {
    Drupal.behaviors.formElementHasBeenFocused = {
        attach: (context) => {

            const forms = context.querySelectorAll(formSelector);

            for (const form of forms) {
                const inputElements = form.querySelectorAll('input, textarea, select');

                for (const inputElement of inputElements) {
                    once(inputElement, 'form-element-has-been-focused-attribute', () => {
                        inputElement.addEventListener('blur', () => {
                            if (inputElement.hasAttribute(focusedAttributeName)) return;
                            requestAnimationFrame(() => inputElement.setAttribute(focusedAttributeName, ''));
                        });
                    });
                }
            }

        },
    };
}
